import  {  useState, useEffect,useRef } from 'react'
import {   Pagination, Autoplay, A11y } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react'; 
import fbicon from '../../assets/images/icons/facebook.svg';
import instaicon from '../../assets/images/icons/instagram.svg';
import youtubeicon from '../../assets/images/icons/youtube.svg';
import AnimatedElement from '../AnimatedElement'; 
import twittericon from '../../assets/images/icons/twitter.svg';
import { useFormik  } from 'formik';
import axios from 'axios';
import * as Yup from 'yup';
import { Modal } from 'react-bootstrap';
import ReCAPTCHA from 'react-google-recaptcha';

export default function Footer()   {
  const [footerMenu, setFooterMenu]= useState([]);
  const [formSendMessage, setMessage] = useState(false);
  const [partnerLogos, setPartnerLogos]= useState([]);
  const [showFormModal, setShow] = useState(false);
    const [captchaToken, setCaptchaToken] = useState(null);
     const recaptchaRef = useRef(null);
  const currentYear = new Date().getFullYear();
  // Function to show the modal
  const handleShow = () => setShow(true);

  // Function to hide the modal
 

  const handleClose = () => {
    formik.resetForm();
    setShow(false);
    setMessage(false);
    if (recaptchaRef.current) {
      recaptchaRef.current.reset(); // Reset the CAPTCHA on modal close
    }
  };
 

useEffect(() => {

      
  const fetchTrusteesData = async () => {
    try {
      const [partner, menuItem] = await Promise.all([
        axios.get(window.$baseUrl + '/footer-partner'),
        axios.get(window.$baseUrl + '/menu_items/footer') 
      ]);

      // Merging the data
      const mergedData = [...partner.data, ...menuItem.data ];
 
      setPartnerLogos(partner.data);
      setFooterMenu(menuItem.data)

    } catch (error) {
      console.error("Error fetching trustees data", error);
    
    }
  };

  fetchTrusteesData();

  
}, []);
 
const formik = useFormik({
  initialValues: {
    name: '',
    email: '',
    message: '',
    number: '',
    captcha: '',
  },
  validationSchema: Yup.object({
    name: Yup.string()
    .matches(/^[A-Za-z ]*$/, 'Only alphabets are allowed')
      .max(15, 'Must be 15 characters or less')
      .required('Please Enter Name / Organisation'),
      number: Yup.number('only numbers are allowed')
      .positive()
      .required('Please Enter Contact Number'),
    message: Yup.string()
      // .max(20, 'Must be 20 characters or less')
      .required('Please Enter Your Query'),
    email: Yup.string().email('Invalid email address').required('Please Enter Email Id'),
    captcha: Yup.string().required('Please complete the CAPTCHA'),
  }),
  onSubmit: async (values) => {
    if (!captchaToken) {
      formik.setFieldError('captcha', 'Please complete the CAPTCHA');
       
      
      return;
    }
    try {
      const csrfResult = await axios.get(window.$name + '/session/token');
      const csrfToken = csrfResult.data;

      const response = await fetch(window.$name + '/webform_rest/submit?_format=json', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': csrfToken,
        },
        body: JSON.stringify({
          webform_id: 'contact',
          name: values.name,
          email: values.email,
          message: values.message,
          contact_no_: values.number,
          captcha_token: captchaToken, // Include the CAPTCHA token
        }),
      });

      const result = await response.json();
      if (response.ok) {
        setMessage('Form Submitted Successfully!!!');
        formik.resetForm();
        setShow(false);
        
      } else {
        console.error('Error in submission:', result);
       
      }
    } catch (error) {
      console.error('Error submitting form:', error);
     
    }
 
  
  },
});

const handleCaptcha = (token) => {
  setCaptchaToken(token);
  formik.setFieldValue('captcha', token);
};


    return (
     <>

<section className=' footer'>
 <div className='tertiary-bgcolor'>
          <div className='container'>
    {Array.isArray(partnerLogos) && partnerLogos.length > 0 && (  
<div className="row align-items-center justify-content-center  partner-logo">
  <AnimatedElement variant="slideUp">
<h2 className='text-center'>Group of Companies</h2>
</AnimatedElement>
             <div className='mt-4'>
                   <AnimatedElement variant="slideUp"   delay={0.5} >
                       <Swiper

            breakpoints={{
              300: {
                allowTouchMove: true,
                slidesPerView: 1
              },
              375: {
                allowTouchMove: true,
                slidesPerView: 1
              },
              575: {
                allowTouchMove: true,
                slidesPerView: 1
              },
              640: {
                allowTouchMove: true,
                slidesPerView: 2
              },

              768: {
                allowTouchMove: true,
                slidesPerView: 3
              },
              991: {
                allowTouchMove: true,
                slidesPerView: 4

              },
              1200: {
                allowTouchMove: false,
                slidesPerView: 6
              },
            }}

            modules={[Pagination, A11y, Autoplay]}
            spaceBetween={20}
            slidesPerView={3}
            pagination={{ clickable: true }}
   
            
            autoplay={{
    delay: 2000,
    disableOnInteraction: false,
  }}
          >

          {partnerLogos.map((postData, index) => (
  <SwiperSlide key={postData.id || index}>
    <div className="item">
      <img
        src={window.$name + postData.field_thumbnail}
        className="img-fluid partner-logos-footer"
        alt={postData.thumbnail_alt}
        title={postData.thumbnail_alt}
      />
    </div>
  </SwiperSlide>
))}

          </Swiper>
                </AnimatedElement>
 </div>
 
 
        
        </div> 

 )}
        </div>
 </div>


     <div className='footer primary-bgcolor mx-auto text-center text-white '>
       
     <div className='container-fluid'>
 

{/* Partner Logo */}


      
     <div className="container footer-menu py-3 test">
        <div className="d-flex">
            <div className="section-1">
            {footerMenu.length > 0 ? (
              footerMenu.map((postData, index) => {
                return (
                  
                  <a href={postData.relative} className="text-white mx-3"  key={index}>{postData.title}</a>
               
                );
              })
            ) : (
              null
            )}


            
            </div>
                 {/* <!-- Social media icons and Quick Enquiry button --> */}
        
            <div  className="align-items-center section-2">
                <a href="https://www.facebook.com/OfficialHindujaFoundation" target='_blank' className="text-white mx-2"><img src={fbicon} style={{aspectRatio: "24/24"}} alt="facebook" /></a>
                <a href="https://twitter.com/HindujaF" target='_blank' className="text-white mx-2"><img src={twittericon}  style={{aspectRatio: "24/24"}} alt="X" /></a>
                <a href="https://www.instagram.com/hindujafoundation/" target='_blank' className="text-white mx-2"><img src={instaicon} style={{aspectRatio: "24/24"}} alt="instagram" /></a>
                <a href="https://www.youtube.com/channel/UCFVes9t9FTT8ux1ktZwUacA" target='_blank' className="text-white mx-2"><img src={youtubeicon} style={{aspectRatio: "24/24"}} alt="youtube"/></a>
 
       
            </div>
             
           <a className='btn-solid-secondary btn  ms-3 arrowBtnWhite'  onClick={handleShow}>Quick Enquiry</a>
           

       
<Modal show={showFormModal} onHide={handleClose} >
        <Modal.Header className='modal-dark'  closeButton>
          <Modal.Title>Enquiry</Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <form onSubmit={formik.handleSubmit} method='POST'>
        <div className='form-group'>
          <label htmlFor="name">Name *</label>
       <input
         id="name"
         name="name"
         type="text"
         onChange={formik.handleChange}
         onBlur={formik.handleBlur}
         value={formik.values.name}
       />
       {formik.touched.name && formik.errors.name ? (
         <div className='errormsg'>{formik.errors.name}</div>
       ) : null}
          </div>
          <div className='form-group'>
    <label htmlFor="email">Email Id *</label>
       <input
         id="email"
         name="email"
         type="email"
         onChange={formik.handleChange}
         onBlur={formik.handleBlur}
         value={formik.values.email}
       />
       {formik.touched.email && formik.errors.email ? (
         <div className='errormsg'>{formik.errors.email}</div>
       ) : null}
    </div>

    <div className='form-group'>
    <label htmlFor="number">Contact Number *</label>
       <input
         id="number"
         name="number"
         type="text"
         onChange={formik.handleChange}
         onBlur={formik.handleBlur}
         value={formik.values.number}
       />
       {formik.touched.number && formik.errors.number ? (
         <div className='errormsg'>{formik.errors.number}</div>
       ) : null}
    </div>

    <div className='form-group'>
<label htmlFor="message">Query *</label>
<textarea  id="message"
         name="message"
         type="text"
         onChange={formik.handleChange}
         onBlur={formik.handleBlur}
         value={formik.values.message} style={{resize:"none"}}></textarea>
      
       {formik.touched.message && formik.errors.message ? (
         <div className='errormsg'>{formik.errors.message}</div>
       ) : null}
</div>

<ReCAPTCHA
              ref={recaptchaRef}
                sitekey="6LdCyPssAAAAAA9cLUmOyD0zsn9IrycTcMLsC9yn"  
                onChange={handleCaptcha}
              />
               {formik.touched.captcha && formik.errors.captcha && (
            <div className="errormsg">{formik.errors.captcha}</div>
          )}
<button type="submit" className='btn-outline-primary btn arrow my-2' style={{float:"right"}}>Submit</button>
    </form>
     
        </Modal.Body>
        
      </Modal>
  
      <div className="message ">{formSendMessage ?    <Modal show={formSendMessage} onHide={handleClose}>
           <Modal.Header closeButton onClick={() => setMessage(false)}>   </Modal.Header>
           <Modal.Body className='text-center pt-4 pb-2'>Form Submitted Successfully!!!</Modal.Body>
           <Modal.Footer style={{margin:"auto", paddingBottom:"2rem"}} ><button   className='btn-outline-primary btn  pe-4 my-0' onClick={() => setMessage(false)} >OK</button> </Modal.Footer>
        </Modal> :  null}</div>  


        </div>
        </div>



     <div className="row py-4">
            <div className="col-12">
                <p className="mb-1">The Foundation is an NGO and is eligible to receive funding both domestic and foreign under Section 135 of the Companies Act 2013.</p>
                <p className="mb-0">&copy; {currentYear} Hinduja Foundation. All rights reserved | Website by <a href="https://www.hgsinteractive.com/" className='text-white' target='_blank'>HGS Interactive</a>, an interactive agency</p>
            </div>
        </div>
     </div>
     
     </div>
     </section>
     </>
    )
  
}
